import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DocumentaAiComponent } from "./documenta-ai.component";
import { DocumentaAiService } from "./services/documenta-ai.service";
import { PoModule } from "@po-ui/ng-components";
import { PoTemplatesModule } from "@po-ui/ng-templates";
import { PoCodeEditorModule } from "@po-ui/ng-code-editor";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [DocumentaAiComponent],
  imports: [
    CommonModule,
    PoModule,
    PoTemplatesModule,
    PoCodeEditorModule,
    FormsModule,
  ],
  exports: [DocumentaAiComponent],
  providers: [DocumentaAiService],
})
export class McpAdminModule {}
